import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=838d29fe&"
import script from "./Header.ts?vue&type=script&lang=ts&"
export * from "./Header.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports